import { useAuth0 } from '@auth0/auth0-react'
import { useAtom } from 'jotai'
import React from 'react'

import { auth0UserAtom } from '~/atoms/auth0UserAtom'
import { useGTag } from '~/common/hooks/useGTag'
import { exists } from '~/utils'

import { Authenticated } from './components/Authenticated'
import { LoadingAuthentication } from './components/LoadingAuthentication'
import { Unauthenticated } from './components/Unauthenticated'

export const Root = () => {
  const { isAuthenticated, isLoading, user } = useAuth0()
  const [auth0User, setAuth0User] = useAtom(auth0UserAtom)

  useGTag()

  React.useEffect(() => {
    setAuth0User(user)
  }, [setAuth0User, user])

  if (exists(auth0User)) {
    return <Authenticated />
  }

  if (isLoading || isAuthenticated) {
    return <LoadingAuthentication />
  }

  return <Unauthenticated />
}
